export default {
  ENTER: 13,
  TAB: 9,
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  ESC: 27,
  SHIFT: 16,
  ALT: 18,
};
